import { render, staticRenderFns } from "./ModificarRol.vue?vue&type=template&id=a98335f4"
import script from "./ModificarRol.vue?vue&type=script&lang=js"
export * from "./ModificarRol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports